import React from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import { CanvasThumb } from './spotifyCanvasRowRules';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Canvas parts; each part uses its own slice of it */
import styles from './SpotifyCanvas.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface CanvasLoopThumbProps {
  thumb: CanvasThumb;
  /** The small Spotify dot: the loop is on Spotify. */
  dot: boolean;
  /** The song cover (the API gives no first frame of the loop). */
  artwork: string | undefined;
}

/** The 9:16 loop of the Canvas line (design spotify-canvas a2, d3): the loop, a dashed box, or dimmed. */
const CanvasLoopThumbComponent: React.FC<CanvasLoopThumbProps> = ({ thumb, dot, artwork }) => (
  <span
    className={clsx(styles.loop, thumb === 'empty' && styles.loopEmpty, thumb === 'dim' && styles.loopDim)}
    style={thumb === 'empty' || artwork === undefined ? undefined : { backgroundImage: `url(${artwork})` }}
    aria-hidden="true"
  >
    {dot && <i className={styles.dot} />}
  </span>
);

export const CanvasLoopThumb = TypedMemo(CanvasLoopThumbComponent);
